// extracted by mini-css-extract-plugin
module.exports = {"footer":"c84d6","resend-link":"c48a5","resendLink":"c48a5","content":"_69beb"};